// document.addEventListener('DOMContentLoaded', () => {
//     console.log('hello good morning');
// });


document.addEventListener("DOMContentLoaded", function() {
    var targetWrapper = document.querySelector(".selector-wrapper.js.product-form__item");
    var subscriptionDiv = document.querySelector("#shopify-block-AYlNWeUNWbStyckVYV__seal_subscriptions_subscription_widget_BQwRQA");

    if (targetWrapper && subscriptionDiv) {
        targetWrapper.appendChild(subscriptionDiv); // Bottom ma add kare
    }
});


document.addEventListener("DOMContentLoaded", function () {

  function moveSealSubs() {
    const sealSubs = document.querySelector('.sealsubs-target-element.sealsubs-full');
    const target = document.querySelector('.selector-wrapper.js.product-form__item');

    if (sealSubs && target && !target.contains(sealSubs)) {
      target.appendChild(sealSubs);
    }
  }

  // First attempt
  moveSealSubs();

  // Observe DOM changes (Seal Subscriptions loads via JS)
  const observer = new MutationObserver(() => {
    moveSealSubs();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
